import React from "react";

const AZ_STEPS = [10, 25, 50, 100, 200];
const EL_STEPS = [10, 25, 50, 100];
const ZM_STEPS = [1, 5, 10, 25];

function PresetNudger({ onNudge, disabled, azStep, elStep, zmStep, onAzStepChange, onElStepChange, onZmStepChange, invertEl }) {
    const az = azStep || 50;
    const el = elStep || 50;
    const zm = zmStep || 10;
    const elDir = invertEl ? -1 : 1;

    const nudge = (azDelta, elDelta, zoomDelta) => {
        if (disabled) return;
        onNudge({ azimuthDelta: azDelta, elevationDelta: elDelta, zoomDelta: zoomDelta });
    };

    return (
        <div className="nudge-controls">
            {/* Step-size selectors */}
            <div style={{ display: "flex", gap: 6, marginBottom: 8, fontSize: 11 }}>
                <div style={{ flex: 1 }}>
                    <label style={{ color: "var(--text-secondary)", display: "block", marginBottom: 2 }}>Az step</label>
                    <select
                        className="filter-select"
                        value={az}
                        onChange={(e) => onAzStepChange && onAzStepChange(Number(e.target.value))}
                        style={{ width: "100%", fontSize: 11, padding: "2px 4px" }}
                    >
                        {AZ_STEPS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div style={{ flex: 1 }}>
                    <label style={{ color: "var(--text-secondary)", display: "block", marginBottom: 2 }}>El step</label>
                    <select
                        className="filter-select"
                        value={el}
                        onChange={(e) => onElStepChange && onElStepChange(Number(e.target.value))}
                        style={{ width: "100%", fontSize: 11, padding: "2px 4px" }}
                    >
                        {EL_STEPS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div style={{ flex: 1 }}>
                    <label style={{ color: "var(--text-secondary)", display: "block", marginBottom: 2 }}>Zm step</label>
                    <select
                        className="filter-select"
                        value={zm}
                        onChange={(e) => onZmStepChange && onZmStepChange(Number(e.target.value))}
                        style={{ width: "100%", fontSize: 11, padding: "2px 4px" }}
                    >
                        {ZM_STEPS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
            </div>

            <div className="nudge-grid">
                {/* Top row */}
                <div className="nudge-spacer" />
                <button
                    className="nudge-btn"
                    onClick={() => nudge(0, el * elDir, 0)}
                    disabled={disabled}
                    title={`Tilt up (${invertEl ? '-' : '+'}${el} elevation)`}
                >
                    &uarr;
                </button>
                <div className="nudge-spacer" />

                {/* Middle row */}
                <button
                    className="nudge-btn"
                    onClick={() => nudge(-az, 0, 0)}
                    disabled={disabled}
                    title={`Pan left (-${az} azimuth)`}
                >
                    &larr;
                </button>
                <div className="nudge-center">
                    <span className="nudge-center-label">PTZ</span>
                </div>
                <button
                    className="nudge-btn"
                    onClick={() => nudge(az, 0, 0)}
                    disabled={disabled}
                    title={`Pan right (+${az} azimuth)`}
                >
                    &rarr;
                </button>

                {/* Bottom row */}
                <div className="nudge-spacer" />
                <button
                    className="nudge-btn"
                    onClick={() => nudge(0, -el * elDir, 0)}
                    disabled={disabled}
                    title={`Tilt down (${invertEl ? '+' : '-'}${el} elevation)`}
                >
                    &darr;
                </button>
                <div className="nudge-spacer" />
            </div>

            <div className="nudge-zoom">
                <button
                    className="nudge-btn nudge-zoom-btn"
                    onClick={() => nudge(0, 0, zm)}
                    disabled={disabled}
                    title={`Zoom in (+${zm})`}
                >
                    Zoom +
                </button>
                <button
                    className="nudge-btn nudge-zoom-btn"
                    onClick={() => nudge(0, 0, -zm)}
                    disabled={disabled}
                    title={`Zoom out (-${zm})`}
                >
                    Zoom -
                </button>
            </div>
        </div>
    );
}

export default PresetNudger;
